import { SharedState, useSharedState } from '@trello/shared-state';

// Used to capture animation complete state for the board menu, so we can
// wait for transition end to show & correctly position a spotlight.
// See https://bitbucket.org/trello/web/src/main/app/src/components/Onboarding/README.md
export const boardSidebarReadyState = new SharedState<boolean | undefined>(
  undefined,
);

export const useIsBoardSidebarReady = () => {
  const [isSidebarReady] = useSharedState(boardSidebarReadyState);
  return isSidebarReady;
};
